import { render } from "./BusinessExpenses.vue?vue&type=template&id=ac617ab6&scoped=true"
import script from "./BusinessExpenses.vue?vue&type=script&lang=js"
export * from "./BusinessExpenses.vue?vue&type=script&lang=js"

import "./BusinessExpenses.vue?vue&type=style&index=0&id=ac617ab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac617ab6"]])

export default __exports__